import { useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

const Settings = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [notifications, setNotifications] = useState(true);
  const [profile, setProfile] = useState({ name: "John Doe", email: "john@example.com" });

  const handleProfileChange = (e) => {
    setProfile({ ...profile, [e.target.name]: e.target.value });
  };

  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 ml-16">
        <Navbar />
        <div className="p-6 mt-16">
          <h2 className="text-2xl font-bold mb-4">Settings</h2>

          {/* Profile Settings */}
          <div className="bg-white shadow-md rounded-lg p-4 mb-4">
            <h3 className="text-xl font-semibold mb-2">Profile Settings</h3>
            <input
              type="text"
              name="name"
              value={profile.name}
              onChange={handleProfileChange}
              className="border p-2 w-full mb-2"
              placeholder="Enter Name"
            />
            <input
              type="email"
              name="email"
              value={profile.email}
              onChange={handleProfileChange}
              className="border p-2 w-full"
              placeholder="Enter Email"
            />
          </div>

          {/* Notification Settings */}
          <div className="bg-white shadow-md rounded-lg p-4 mb-4">
            <h3 className="text-xl font-semibold mb-2">Notification Settings</h3>
            <label className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={notifications}
                onChange={() => setNotifications(!notifications)}
              />
              <span>Enable Email Notifications</span>
            </label>
          </div>

          {/* Theme Settings */}
          <div className="bg-white shadow-md rounded-lg p-4">
            <h3 className="text-xl font-semibold mb-2">Theme Settings</h3>
            <button
              className={`p-2 rounded ${darkMode ? "bg-gray-800 text-white" : "bg-gray-200"}`}
              onClick={() => setDarkMode(!darkMode)}
            >
              {darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
